export const getTrails = (trails) => ({
  type: 'GET_TRAILS',
  trails,
});

export const makeBooking = (booking) => ({
  type: 'MAKE_BOOKING',
  booking,
});
